import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { SessionStorageService, SessionStorage } from 'ngx-webstorage';
import { RoutePath } from '../../routing/routes';
import { UserInfo, UserRole } from './user';
import { MultiplePathwaysSerivce } from '../mainapp/multiplePathways.service';


@Injectable( { providedIn: 'root' } )
export class UserService {
    @SessionStorage() private _User!: UserInfo | null;

    UserSubject: BehaviorSubject<UserInfo | null> = new BehaviorSubject<UserInfo | null>(null);

    get User(): UserInfo | null {
        return this._User;
    }

    set User(_ui: UserInfo | null) {
        this._User = _ui;
        this.UserSubject.next(_ui);
    }

    public get UserValue(): UserInfo | null {
        return this.UserSubject.value;
    }

    constructor(
        private REALService: MultiplePathwaysSerivce,
        private storage: SessionStorageService, 
        private router: Router, 
        private sessionService: SessionStorageService
    ) {
        this.UserSubject.next(this._User);
    }

    // #region Clear User Service Call

    ClearUser() {
        this.User = null;
        this.sessionService.clear('_User');

        // Clear out all session specific settings.
        this.sessionService.clear('_currentschool');
        this.REALService.SetSelectedSchoolYear(null);
        this.sessionService.clear('_selectedschoolyear');
    }

    // #endregion

    SetUser(user: UserInfo) {
        this.User = user;
    }

    // #region Set User Current Role Service Call

    SetUserCurrentRole(role: UserRole, roleName: string | null = null, oldRole: UserRole | null = null) {
        if (this.User!.CurrentRole != null && role === this.User!.CurrentRoleInfo && oldRole != null && role === oldRole) {
            return;
        }

        // To trigger proper session storage, we need to create a new object reference, rather than just updating our existing User object.
        const newUser: UserInfo = JSON.parse(JSON.stringify(this.User)) as UserInfo;

        // Update the current role field.
        newUser.CurrentRole = roleName ? roleName : this.User!.CurrentRoleInfo!.RoleName;
        newUser.CurrentRoleInfo = role;

        // Now, persist it to session storage and then broadcast it for listeners.
        this.User = newUser;

        // Temporary disabled login access for roles below Clearinghouse while making new changes - EE 2024/06/17
        if (!(
            this.User.CurrentRoleInfo?.IsProgramContact
            || this.User.CurrentRoleInfo?.IsDistrictStaff
            || this.User.CurrentRoleInfo?.IsPrincipal
            || this.User.CurrentRoleInfo?.IsAssistantPrincipal
            || this.User.CurrentRoleInfo?.IsCounselor
            || this.User.CurrentRoleInfo?.IsSuccessCoach
            || this.User.CurrentRoleInfo?.IsStudentAdvisor
            || this.User.CurrentRoleInfo?.IsDesignee
            || this.User.CurrentRoleInfo?.IsReader
        )) {
            // Go to the home screen for this role, or force a home screen refresh if already on home screen.
            // RoutePath.Maintenance is just a dummy route for the sake of homepage reload on role change.
            this.router.navigateByUrl(RoutePath.Maintenance, { skipLocationChange: true }).then(() => {
                this.router.navigate([RoutePath.Home]);
            }); 
        }
    }

    // #endregion

    // #region Update AuthToken Service Call

    UpdateAuthToken(AuthToken: any) {
        // If the authtoken has changed, update the user record.
        if (AuthToken !== this.User!.AuthToken) {
            // To trigger proper session storage, we need to create a new object reference, rather than just updating our
            // existing User object.
            const newUser: UserInfo = <UserInfo>JSON.parse(JSON.stringify(this.User));

            // Update the AuthToken field
            newUser.AuthToken = AuthToken;

            // Now, persist it to session storage and then broadcast it for listeners
            this.User = newUser;
        }
    }

    // #endregion
}
